import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, browserHistory } from 'react-router';

import watchParamsForStore from 'es6/core/watch-params-for-store';
import ItemsContainer from 'es6/containers/items';
import itemsStore from 'es6/redux/stores/items';
import { loadItemAction } from 'es6/redux/sagas/items';
import ErrorDecorator from 'es6/components/layout/error-decorator';

const store = itemsStore();
const watchParams = watchParamsForStore(store);

function initApp(env) {
  ReactDOM.render(renderRouter(), document.querySelector('#primary-content'));
}

function renderRouter() {
  return (
    <Provider store={store}>
      <Router history={browserHistory}>
        <Route path="/items/:id(/:slug)" component={ItemsContainer}
               { ...watchParams(({ id }) => loadItemAction(id)) } />
      </Router>
    </Provider>
  );
}

window.initApp = initApp;
